import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortBy', standalone: false })
export class SortByPipe implements PipeTransform {
  transform(array: any[], field: string, dir: 'asc' | 'desc' = 'asc'): any[] {
    if (!array || !field) return array;
    return [...array].sort((a, b) => {
      const rawA = a[field] ?? '';
      const rawB = b[field] ?? '';
      const va = rawA !== '' && !isNaN(Number(rawA)) ? Number(rawA) : rawA;
      const vb = rawB !== '' && !isNaN(Number(rawB)) ? Number(rawB) : rawB;
      const cmp = va < vb ? -1 : va > vb ? 1 : 0;
      return dir === 'asc' ? cmp : -cmp;
    });
  }
}
